module.exports = __webpack_public_path__ + "win-8639d81e9a4f3961c87e.png";